import React from 'react';
import {parseSopRoleSections, responsibilitiesForRole} from '../utils/sopRoleSections';

const textStyle = {whiteSpace:'pre-wrap', lineHeight:1.75, color:'#3B2A21', fontSize:14, overflowWrap:'anywhere'};
function BodyText({text}) {
  return <div style={textStyle}>{text.split(/\r?\n/).map((line, index) =>
    <React.Fragment key={index}>{/^\d+(?:\.\d+)*\.\s+[A-Z]/.test(line) ? <strong>{line}</strong> : line}{'\n'}</React.Fragment>
  )}</div>;
}
export default function SopRoleContent({content, role}) {
  const parts = parseSopRoleSections(content);
  const personal = responsibilitiesForRole(parts, role);
  const structured = parts.some(part => part.roles);
  const roleName = String(role || '').replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  return <div style={{padding:'24px 28px', maxWidth:920}}>
    {structured && <section aria-label="Your responsibilities" style={{background:'#F2EFE7', border:'3px solid #556B2F', borderRadius:10, padding:20, marginBottom:24}}>
      <h3 style={{fontSize:21, fontWeight:900, color:'#3B2A21', margin:'0 0 12px'}}>YOUR RESPONSIBILITIES — {roleName || 'Account role unavailable'}</h3>
      {personal.length ? personal.map((part,index) => <div key={index} style={{marginBottom:12}}>
        <h4 style={{fontSize:17, fontWeight:800, margin:'8px 0'}}>{part.title}</h4><BodyText text={part.text}/>
      </div>) : <p>No separate responsibility section is assigned to your account role in this SOP. Read the full workflow below and ask the process owner to clarify any assigned duties.</p>}
      <p style={{fontWeight:700, marginBottom:0}}>Read the complete SOP below to understand the checks, handovers and approval limits.</p>
    </section>}
    {structured && <h3 style={{fontWeight:900, fontSize:20, color:'#3B2A21'}}>FULL SOP — COMPLETE WORKFLOW</h3>}
    {parts.map((part,index) => part.roles ? <section key={index} style={{padding:16, margin:'16px 0', border:personal.includes(part) ? '3px solid #556B2F' : '1px solid #ddd', borderRadius:8, background:personal.includes(part) ? '#F2EFE7' : '#fff'}}>
      <h4 style={{fontSize:18, fontWeight:900, color:'#3B2A21', margin:'0 0 10px'}}>{part.title}{personal.includes(part) && <span style={{display:'block', color:'#556B2F', fontSize:14, marginTop:5}}>YOUR RESPONSIBILITY</span>}</h4>
      <BodyText text={part.text}/>
    </section> : <BodyText key={index} text={part.text}/>)}
  </div>;
}
